<template>
  <a
    :href="link.url"
    :target="link.newWindow ? '_blank' : '_self'"
    :title="link.title"
    @mouseenter="noHover = false"
    @mouseleave="noHover = true"
  >
    <template
      v-if="
        link.icon === 'fas fa-envelope' ||
        link.icon === 'fa-envelope' ||
        link.icon === 'far fa-envelope'
      "
    >
      <Icon name="mail" size="large" />
    </template>
    <template v-else>
      <i :class="[link.icon, { noHover: noHover }]" :style="{ background: link.color }" />
    </template>
    <span v-if="showLabel" v-text="link.text" />
  </a>
</template>

<script setup>
import { ref } from 'vue';
import Icon from '../Icon/Icon.vue';

defineProps({
  showLabel: {
    type: Boolean,
    default: false,
  },
  link: {
    type: Object,
    default: () => {},
  },
});

const noHover = ref(true);
</script>
